export default __webpack_public_path__ + "static/media/marketing.e2ae5829.svg";